<form #myForm="ngForm">
    <div class="container-fluid forgot_wrapper">
        <div class="row reg_bg">
            <div class="col-lg-1 col-md-1"></div>
            <div class="col-lg-3 col-md-3 forgot_left">
                <img src="/assets/images/ots_logo.png">
                <h5>Welcome</h5>
                <span>
                  Registration: Lorem ipsum dolor sit, consectetur adipiscing elit. Aliquam tristique ipsum ac velit sodales scelerisque. Nam
                  euismod nec quam nec vulputate.
              </span>
            </div>
            <div class="col-lg-1 col-md-1" style="text-align: left"></div>
            <div class="col-lg-4 col-md-4 xs-3" style="text-align: left;">
                <div *ngIf="FieldToggle">
                    <strong class="titleV1">Forgot Password</strong>
                    <div class="input-field addMandatory">
                        <input name="Email" type="text" class="validate" [pattern]="emailPattern" (input)="clearWrongEmailMsg()" (blur)="validateEmail(myForm)"
                            required placeholder="Email" [(ngModel)]="Email">
                    </div>
                    <div *ngIf="MailPatternInvalid">
                        <span class="input-ErrorField">Please enter a valid email id</span>
                    </div>
                    <!-- <div *ngIf="MailInvalid">
                        <span class="input-ErrorField">Please enter your registered email id</span>
                    </div> -->
                    <div class="addMandatory">
                        <p-select name="test" [options]="QuestionDetail" [autoWidth]="false" (ngModelChange)="clearWrongQuestionMsg()" [style]="{'width':'100%', 'margin-top': '30px'}"
                            [(ngModel)]="Question" placeholder="Security Question" appendTo="body" optionLabel="question">
                          <ng-template pTemplate="selectedItem" let-selectedOption>
                            {{ selectedOption?.question }}
                          </ng-template>
                          <ng-template pTemplate="item" let-option>
                            {{ option.question }}
                          </ng-template>
                        </p-select>
                    </div>
                    <!-- <div *ngIf="QuestionInvalid">
                        <span class="input-ErrorField">Please choose your correct security question</span>
                    </div> -->
                    <div *ngIf="QuestionEmpty">
                        <span class="input-ErrorField">Please choose a security question</span>
                    </div>
                    <div class="input-field addMandatory">
                        <input name="Answer" type="text" class="validate" required placeholder="Answer" (input)="clearWrongAnswerMsg()" [(ngModel)]="Answer"
                            maxlength="50">
                    </div>
                    <!-- <div *ngIf="AnswerInvalid">
                        <span class="input-ErrorField">Please choose correct answer for your security question</span>
                    </div> -->
                    <div *ngIf="AnswerEmpty">
                        <span class="input-ErrorField">Please provide an answer</span>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 submitbtn_main" (click)="onSubmit(myForm)">
                        <a class="waves-effect waves-light btn submitcustom_btn">Submit</a>
                    </div>
                </div>
                <div *ngIf="!FieldToggle" class="forgot_left newPassword">
                    <!-- A new password has been generated and sent to your registered email. Please check your email. -->
                     If your registered email and security question is valid then a new password will be sent to your registered email.Please check your email.
                </div>
            </div>
            <div class="col-lg-3 col-md-3" style="text-align: left"></div>
        </div>
    </div>
</form>